import React, {memo, useCallback, useEffect, useMemo, useState} from 'react';
import {BrowserRouter as Router, Redirect, Route, Switch, useLocation, useParams} from 'react-router-dom';
import {isBrowser, isMobile} from 'react-device-detect';
import NotFound from './components/NotFound';
import GlobalStyles from './styled/GlobalStyles';
import i18nInit from "./i18n";
import i18next from "i18next";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {changeVersion, CLOUDFLARE_VERSION} from "./store/modules/gameVersion";
import {imageStore} from "./store/modules/imageStore";
import ChampionsDetail from "./components/ChampionsDetail";
import Champions from "./components/Champions";
import styled, {ThemeProvider} from "styled-components";
import Ranking from "./components/Ranking";
import Aram from "./components/Aram";
import Balance from "./components/balance";
import {getDataDragonRegion} from "./i18n/languages";
import {translation} from "./store/modules/translation";
import Mastery from "./components/mastery";
import {dark, darkIcon, light, lightIcon} from "./common/theme";
import SpectateLivePro from "./components/Spectate/live/pro";
import {Footer, Loading, ToMobile} from "./components/common";
import {Summoner} from "./components/summoner";
import Home from "./components/home/Home";
import URF from "./components/urf";
import SummonerSearch from "./components/SummonerSearch";
import Pro from "./components/pro";
import Strm from "./components/page/Strm";
import DataLayer from "./components/DataLayer/DataLayer";
import CheckDataLayer from "./components/DataLayer/CheckDataLayer";
import {isbot} from "isbot";
import NewsList from "./components/marquee/newsList";
import SetDefaultDataLayer from "./components/DataLayer/SetDefaultDataLayer";
import Privacy from "./components/Privacy";
import Advertise from "./components/Advertise";
import ProsperNewSession from "./components/ad/VenatusNewSession";
import {secretApi} from "./api/api";
import Event from "./components/Event";
import Sll from "./components/sll/sll";
import Tracker from "./Tracker/Tracker";
import Llm from "./components/llm/llm";
import {SET_ITEM, SET_RUNE, SET_SPELL} from "./store/reducer/imageStore";
import {GET_CHAMPIONS_VERSIONS_SUCCESS} from "./store/reducer/champions";
import {kataToHira} from "./function";
import EventMang from "./components/EventMang/EventMang";
import CustomClan from "./components/CustomClan/CustomClan";
import CustomClanDetail from "./components/CustomClan/Detail/CustomClanDetail";
import SllWinter from "./components/sll/SllWinter/SllWinter";
import SllTierRun from "./components/sll/sllTierRun/sllTierRun";
import Gosegu from "./components/Event/Gosegu/Gosegu";
import Mang from "./components/mang/Mang";


const AppWrapper = styled.div`
  height: 100%;
  overflow: hidden;
`;

const LoadingWrapper = styled.div`
  width: 100vw;
  height: 100vh;
`;


const Anchor = styled.div`
  position: fixed;
  bottom: 0;
  width: 1080px;
  left: 50%;
  transform: translate(-50%, 0);
`;
// 스토어생성
i18nInit();

const App = () => {
    const params = useParams();
    const dispatch = useDispatch();
    const {t, i18n} = useTranslation();
    const [loading, setLoading] = useState(true);
    const location = useLocation();
    const currentLang = useSelector((state) => state.translation.lang);
    const region = useSelector((state) => state.region.result);
    const choArr = useMemo(() => ["ㄱ", "ㄲ", "ㄴ", "ㄷ", "ㄸ", "ㄹ", "ㅁ", "ㅂ", "ㅃ", "ㅅ", "ㅆ", "ㅇ", "ㅈ", "ㅉ", "ㅊ", "ㅋ", "ㅌ", "ㅍ", "ㅎ"], []);
    const themeColor = useSelector((state) => state.theme.color);
    if (document) {
        const canonical = document.querySelector('link[rel=canonical]');
        canonical.setAttribute("href", window.location.href);
    }
    const version = useSelector((state) => state?.gameVersion.version);

    useEffect(() => {
        if (document) {
            const canonical = document.querySelector('link[rel=canonical]');
            const langAlter = document.querySelectorAll('link[rel=alternate]');

            langAlter.forEach((data) => {

                const lang = data.getAttribute('hreflang')
                if (lang === 'x-default') {
                    data.setAttribute('href', `https://www.deeplol.gg${location.pathname}`)
                } else {
                    data.setAttribute('href', `https://www.deeplol.gg${location.pathname}?hl=${lang}`)
                }
                // data.setAttribute('href',)
            })

            canonical.setAttribute('href', `https://www.deeplol.gg${location.pathname}?hl=${i18n.language}`)
        }
    }, [location.pathname])

    const handleDescription = () => {
        const htmlTag = document.querySelector('html');
        const description = document.querySelector('meta[name=description]');
        const ogDescription = document.querySelector('meta[property="og:description"]');
        const snsDescription = document.querySelector('meta[property="twitter:description"]');
        const contentLanguage = document.querySelector('meta[http-equiv="content-language"]');
        const enDescription = 'DEEPLOL provides new strategies such as AI-score and Tier Prediction with AI technology. Check out AI-score, like Pro LoL teams.';
        const korDescription = '롤전적 검색 딥롤은 인공지능(AI) 기술로 AI Score, 티어 예측과 같은 새로운 게임 데이터를 제공합니다. 롤 프로팀도 사용하는 AI-score를 지금 확인해보세요!';
        const thisDes = currentLang === 'KOR' ? korDescription : enDescription;

        contentLanguage.setAttribute('content', i18n.language);
        description.setAttribute('content', thisDes);
        ogDescription.setAttribute('content', thisDes);
        snsDescription.setAttribute('content', thisDes);
        htmlTag.setAttribute('lang', i18n.language);
    }

    const changeKeywords = (data) => {
        document.documentElement.lang = data[0] + data[1];
        const keywords = document.querySelector('meta[name=keywords]');
        keywords.setAttribute('content', t('header.keywords'));
    };

    const getGameVersion = useCallback(async () => {
        try {
            const url = `${process.env.REACT_APP_CACHE_API}champion/version?cnt=2`;
            const result = await secretApi.get(url).then((result) => result.data);
            const championVersion = result?.game_version_list;
            const recentVersion =  result?.recent_version ?? '15.16'
            dispatch({
                type: GET_CHAMPIONS_VERSIONS_SUCCESS,
                data: {
                    versions: championVersion,
                }
            })
            const resultVersion = `${recentVersion}.1`
            dispatch(changeVersion(resultVersion, [resultVersion]));
            return resultVersion
        } catch (e) {
            return "15.16.1";
        }
    }, []);

    const setChoName = useCallback((value) => {
        if (typeof value === 'string') {
            let result = "";
            for (let char of value) {
                if (char === "") {
                    continue;
                }
                if (char.charCodeAt() > 44031) {
                    const choValue = Math.trunc((char.charCodeAt() - 44032) / 588);
                    result += choArr[choValue];
                } else {
                    result += char;
                }

            }
            return result;
        }
    }, []);
    const setChampLang = (champion, resChampion) => {
        return resChampion.map((data) => {
            const findData = champion.find((champ) => champ.key === data.champion_id);
            if(currentLang === 'ja') {
                return {
                    ...data,
                    champion_name: findData?.name,
                    cho_name: kataToHira(findData?.name)
                }
            }
            return {
                ...data,
                champion_name: findData?.name,
            }
        })
    }


    const setChoNamedChampion = useCallback((data) => {
        let choNamedChampions
        if (Array.isArray(data)) {
            choNamedChampions = data.map((data, index) => {
                let choname = data.champion_name_en
                if(data.champion_name_kr) {
                   choname =  setChoName(data.champion_name_kr)
                }

                const imageNameReplace = data.image_name.replace('.png', '');
                return {
                    ...data,
                    image_name: imageNameReplace,
                    cho_name: choname
                }
            })
        }
        return choNamedChampions;
    }, []);

// 챔피언, 룬, 스펠, 아이템 스토어 등록 (이미지용)
    const getImageInfo = useCallback(async () => {
        try {

            const gameVersion = await getGameVersion();
            let _thisGameVersionArr = gameVersion.split('.');
            let _thisGameVersion = _thisGameVersionArr[0] + '.' + _thisGameVersionArr[1];
            dispatch({
                type: CLOUDFLARE_VERSION,
                data: _thisGameVersion,
            })

            handleDescription();
            const riot_data_url = new URL(`${process.env.REACT_APP_CACHE_API}common/riot_data`)
            riot_data_url.searchParams.set('country_code', getDataDragonRegion(i18n.language));
            riot_data_url.searchParams.set('version', _thisGameVersion);
            const [riot_data, resChampions] = await Promise.all([
                secretApi.get(riot_data_url.toString()),
                secretApi.get(`${process.env.REACT_APP_CACHE_API}common/champion-info?version=${_thisGameVersion}.1`),
                // secretApi.get(`${process.env.REACT_APP_RUNE}?version=${_thisGameVersion}&lang=${getDataDragonRegion(i18n.language)}`),
                // secretApi.get(`${process.env.REACT_APP_SPELL}?version=${_thisGameVersion}&lang=${getDataDragonRegion(i18n.language)}`),
                // secretApi.get(`${process.env.REACT_APP_ITEM}?version=${_thisGameVersion}&lang=${getDataDragonRegion(i18n.language)}`),
            ])


            const data = riot_data.data
            const resChampionLang = data.champion_json.data
            const item_json = data.item_json.data
            const runes_json = data.runes_json
            const spell_json = data.spell_json.data
            dispatch({
                type: SET_RUNE,
                data: runes_json,
            })
            dispatch({
                type: SET_SPELL,
                data: spell_json,
            })

            if (item_json?.[6701]) {
                if (getDataDragonRegion(i18n.language) === 'ko_KR') {
                    item_json[6701].description = "<mainText><stats>공격력 <attention>55</attention><br>물리 관통력 <attention>18</attention><br>이동 속도 <attention>5%</attention></stats><br><br><passive>준비</passive><br>8초 동안 챔피언과 전투를 벌이지 않으면 물리 관통력이 5 ~ 10레벨 증가합니다. 이 물리 관통력 증가 효과는 챔피언에게 피해를 입힐 경우 3초 후에 사라집니다.<br><br><passive>탈출</passive><br>피해를 입힌 챔피언이 3초 안에 죽으면 1.5초 동안 이동 속도가 150 증가했다가 점차 감소합니다.</mainText>"

                } else if (getDataDragonRegion(i18n.language) === 'en_US') {
                    item_json[6701].description = "<mainText><stats><attention>55</attention> Attack Damage<br><attention>18</attention> Lethality<br><attention>5%</attention> Move Speed</stats><br><br><passive>Preparation</passive><br>After being out-of-combat with enemy champions for 8 seconds, gain 5 − 10 (based on level) lethality. This bonus remains for 3 seconds after dealing damage to an enemy champion.<br><br><passive>Extraction</passive><br>Scoring a Damage rating takedown against an enemy champion within 3 seconds of damaging them grants you 150 bonus movement speed that decays over 1.5 seconds.</mainText>"
                }
            }
            dispatch({
                type: SET_ITEM,
                data: item_json,
            })





            // const [season, getAiData, oldSeason, getItemInfo, argments] = await Promise.all([
            //     secretApi.get(`${process.env.REACT_APP_CACHE_API}common/season-list`),
            //     secretApi.get(`${process.env.REACT_APP_CACHE_API}common/tier-boundary`),
            //     secretApi.get(`${process.env.REACT_APP_CACHE_API}common/old-season`),
            //     secretApi.get(`${process.env.REACT_APP_CACHE_API}common/item-info`),
            //     secretApi.get(`${process.env.REACT_APP_ROOT_IMG}latest/cdragon/arena/${getDataDragonRegion(i18n.language).toLowerCase()}.json`),
            //     secretApi.get(`${process.env.REACT_APP_NEW_API}common/country`).catch(() => 'KR'),
            //     secretApi.get(`https://raw.communitydragon.org/latest/plugins/rcp-be-lol-game-data/global/${i18n.language === 'KOR' ? 'ko_kr' : 'default'}/v1/challenges.json`).catch((e) => [])
            // ])
            const browserLang = navigator?.language ? navigator?.language : navigator?.userLanguage
            const country = browserLang.substring(0, 2).toUpperCase() === 'KO' ? 'KR' : 'ELSE'


            // if (Array.isArray(getStreamerTag?.data?.stream_pro_tag)) {
            //     arrayStreamerTag = getStreamerTag.data.stream_pro_tag.map((data) => {
            //         return {
            //             ...data,
            //             puu_id: data.b2c_key_puuid,
            //         }
            //     })
            // } else {
            //     arrayStreamerTag = [];
            // }


            const tooltipReady = true;
            const choNamedChampions = setChoNamedChampion(resChampions?.data?.champions);
            const setLangNames = setChampLang(Object.values(resChampionLang), choNamedChampions);

            dispatch(
                imageStore(
                    setLangNames,
                    tooltipReady,
                    country,
                )
            );
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    }, [i18n.language]);

    useEffect(() => {
        if (!isMobileMemo) {
            sessionStorage.setItem('tempPuuId',localStorage.getItem('tempPuuId'));
            getImageInfo();
        }
    }, [getImageInfo]);


    useEffect(() => {
        dispatch(translation(i18n.language));
    }, [i18n.language])


    i18next.on("languageChanged", changeKeywords);

    const isMobileMemo = useMemo(() => {
        if(process.env.REACT_APP_PROCESS === 'development') {
            return false;
        }
        const multi = /multi|event/g
        const pathname = location.pathname;
        const from = new URLSearchParams(location.search);
        if (from.get('from') === 'mobile') {
            return false;
        }
        if (multi.test(pathname)) {
            return false;
        }
        return !isBrowser

    }, [location, isMobile]);

    //
    if (loading && !isMobileMemo) {
        return <LoadingWrapper><Loading/></LoadingWrapper>
    }
    //
    // return (
    //     <Maintenance/>
    // )
    const theme = {
        color: themeColor === 'light' ? light : dark,
        icon: themeColor === 'light' ? lightIcon : darkIcon
    }


    const IsOnlyMobile = () => {
        if(process.env.REACT_APP_PROCESS === 'development') {
            return false;
        }
        const from = new URLSearchParams(location.search);
        if (from.get('from') === 'mobile') {
            return false;
        }
        if (isbot(navigator.userAgent)) {
            return false;
        } else if (isMobile) {
            return true;
        }
        return false;
    }


    return (
        <DataLayer>
            <ProsperNewSession/>
            <SetDefaultDataLayer>
                <ThemeProvider theme={theme}>
                    <GlobalStyles/>
                    {/*<BottomRightFloatingAd/>*/}
                    <AppWrapper>
                        <Router>
                            {/*<Suspense ={null}>*/}
                            {/*    <Marquee/>*/}
                            {/*</Suspense>*/}
                            <Switch>
                                {/*<Route path="/multi/:region/:name">*/}
                                {/*    <Multi/>*/}
                                {/*    <Footer*/}
                                {/*    />*/}
                                {/*</Route>*/}
                                {/*<Route path="/multi">*/}
                                {/*    <Multi/>*/}
                                {/*    <Footer*/}
                                {/*    />*/}
                                {/*</Route>*/}

                                <Route path={'/lck/:team'} exact>
                                    {/*<ExtraEvent/>*/}
                                    <Event/>
                                </Route>
                                {/*<Route path={'/lilpa700'}>*/}
                                {/*    <ExtraEvent/>*/}
                                {/*</Route>*/}
                                {/*<Route path={'/extra'}>*/}
                                {/*    <KcEvent/>*/}
                                {/*</Route>*/}
                                {/*<Route path="*" component={ToMobile}></Route>*/}
                                {IsOnlyMobile() &&
                                    <Route path="*" component={ToMobile}></Route>}
                                <Route exact path={'/privacy'}>
                                    <Privacy/>
                                    <Footer
                                    />
                                </Route>
                                <Route exact path={'/advertise'}>
                                    <Advertise/>
                                    <Footer
                                    />
                                </Route>
                                <Route exact path="/">
                                    <Home/>
                                    <Footer
                                    />
                                </Route>
                                <Route exact path={'/pro/:proName'}>
                                    <Pro/>
                                    <Footer
                                    />

                                </Route>
                                <Route exact path={'/strm/:proName'}>
                                    <Strm/>
                                    <Footer
                                    />

                                </Route>
                                <Route exact path={'/spectate/live/pro'}>
                                    <SpectateLivePro/>
                                    <Footer
                                    />

                                </Route>

                                <Route path="/summoner/search/:platform/:summonerName">
                                    <SummonerSearch/>
                                    <Footer
                                    />

                                </Route>
                                <Route exact path="/summoner/:region/:userName/matches/:matchId">
                                    <CheckDataLayer>
                                        <Summoner/>
                                        <Footer
                                        />

                                    </CheckDataLayer>
                                </Route>
                                <Route path="/summoner/:region/:userName">
                                    <CheckDataLayer>
                                        <Summoner/>
                                        <Footer
                                        />

                                    </CheckDataLayer>
                                </Route>

                                <Route exact path="/summoner/:region">
                                    <Redirect to={'/'}/>
                                </Route>
                                <Route path="/champions/:champName">
                                    <ChampionsDetail/>
                                    <Footer
                                    />

                                </Route>
                                <Route exact path="/champions">
                                    <Champions/>
                                    <Footer
                                    />

                                </Route>
                                <Route exact path="/aram">
                                    <Aram/>
                                    <Footer
                                    />

                                </Route>
                                <Route exact path="/urf">
                                    <URF/>
                                    <Footer
                                    />

                                </Route>
                                <Route exact path="/mastery">
                                    <Mastery/>
                                    <Footer
                                    />

                                </Route>
                                <Route path="/balance">
                                    <Balance/>
                                    <Footer
                                    />

                                </Route>
                                <Route exact path="/ranking/:platform/:position">
                                    <Ranking/>
                                    <Footer
                                    />
                                </Route>
                                <Route exact path="/daily/ai/:platform/:queue(aram)">
                                    <Redirect to={'/'}/>
                                    {/*<AramDaily/>*/}
                                    {/*<Footer*/}
                                    {/*/>*/}

                                </Route>
                                <Route exact path="/daily/ai/:platform/:queue/:tier">
                                    <Redirect to={'/'}/>
                                    {/*<Daily/>*/}
                                    {/*<Footer*/}
                                    {/*/>*/}
                                </Route>
                                {/*<Route exact path={'/test'}>*/}
                                {/*    <Test/>*/}
                                {/*</Route>*/}
                                <Route exact path={'/story'}>
                                    <NewsList/>
                                </Route>
                                <Route exact path={'/sll'}>
                                    <Sll/>
                                </Route>
                                <Route exact path={'/sll/winter'}>
                                    <SllWinter/>
                                </Route>
                                <Route exact path={'/soop/tierrun'}>
                                    <SllTierRun/>
                                </Route>
                                <Route exact path={'/mgh'}>
                                    {/*<EventGyul/>*/}
                                    <Mang/>
                                </Route>
                                <Route exact path={'/tracker'}>
                                    <Tracker/>
                                </Route>
                                <Route exact path={'/llm'}>
                                    <Llm/>
                                </Route>

                                <Route exact path={'/segucup'}>
                                    <Gosegu/>
                                </Route>
                                <Route exact path={'/event'}>
                                    <EventMang/>
                                </Route>
                                <Route exact path={'/connect/:clanName'}>
                                    <CustomClanDetail/>
                                </Route>
                                <Route exact path={'/connect'}>
                                    <CustomClan/>
                                </Route>
                                <Route>
                                    <NotFound/>
                                    <Footer
                                    />
                                </Route>
                            </Switch>
                        </Router>
                    </AppWrapper>
                </ThemeProvider>
            </SetDefaultDataLayer>
        </DataLayer>
    );
};

const FloatingAd = styled.div`
  position: fixed;
  right: 0;
  bottom: 0;
  width: 300px;
  z-index: 999999999;
`;

const VideoAd = styled.div`
  width: 100%;
  height: 100%;
  --ad-width: 300px;
`;

const BottomRightFloatingAd = memo(() => {


    return (
        <FloatingAd>
            <VideoAd data-ad={'video-top'}/>
        </FloatingAd>
    )
})

export default App;
